import type { TFunction } from 'i18next'
import type { IntroStepId } from './steps'

/** Schritte mit eigener Web-Fassung: Im Browser gibt es kein globales Kürzel, nur `Q`. */
const WEB_VARIANT: readonly IntroStepId[] = ['quickadd']

export type IntroTextKind = 'title' | 'short' | 'long' | 'learn'

/**
 * Text eines Schritts. `quickAddKeys` ist das Kürzel der Schnelleingabe, wie es auf der Tastatur steht
 * (`quickAddShortcutText`): ⌥ Leertaste, Alt+Umschalt+N — im Web `Q`.
 */
export function introStepText(t: TFunction, step: IntroStepId, kind: IntroTextKind, options: { web: boolean; quickAddKeys: string }): string {
  const key = options.web && (kind === 'short' || kind === 'long') && WEB_VARIANT.includes(step) ? `${kind}Web` : kind
  return t(`intro.steps.${step}.${key}`, { qa: options.quickAddKeys })
}
